import { connect } from 'react-redux'
import { showModal } from 'redux/modules/modals'
import CustomersComponent from '../components/CustomersComponent'

const mapActionCreators = {
  showModal
}

const mapStateToProps = state => {
  return {
    customers: state.customers.list
  }
}

export default connect(mapStateToProps, mapActionCreators)(CustomersComponent)



// WEBPACK FOOTER //
// ./src/routes/Customers/containers/CustomersContainer.js